import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { ToastContext } from 'app/context/ToastContext';
import { useNavigate, useParams } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { downloadDocument, getEmailMessage } from 'app/api/emailMessageApi';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SortOrder } from 'primereact/api';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { Chips } from 'primereact/chips';

const MailInboxDetail = () => {
  const { id } = useParams<{ id?: string }>();
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [prilohy, setPrilohy] = useState([]);
  const account = useAppSelector(state => state.authentication.account);
  const isAdminOrAssistant = hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT]);
  const [selectedEmails, setSelectedEmails] = useState([]);

  useEffect(() => {
    if (id) {
      getEmailMessage(id)
        .then(response => {
          setPrilohy(response.data?.attachments);
          setData(response.data);

          if (response.data.to) {
            setSelectedEmails(response.data.to.split(';'));
          }
        })
        .catch(e => {
          console.error(e);
          showError('Chyba', e.response?.data.detail);
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  const onDownload = rowData => {
    downloadDocument(rowData);
  };

  const actionBodyDocumentsTemplate = rowData => {
    return (
      <React.Fragment>
        <div className="flex justify-content-around">
          {<Button icon="pi pi-download" type="button" rounded outlined className="mr-2" onClick={e => onDownload(rowData)} />}
        </div>
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-wrap align-items-center justify-content-between gap-2">
      <span className="text-xl text-900 font-bold">Prílohy</span>
    </div>
  );

  return (
    <div className="card">
      <div style={{ display: 'flex' }}>
        {loading && (
          <div className="flex justify-content-center">
            <ProgressSpinner />
          </div>
        )}
        {!loading && data && (
          <div className="surface-section grid mt-4 grid-nogutter formgrid p-4 gap-3 md:surface-border md:border-1 border-round">
            {isAdminOrAssistant && (
              <>
                <div className="col-12 field">
                  <label htmlFor="to" className="text-900 font-semibold">
                    Komu
                  </label>
                  <Chips id="email-chips" value={selectedEmails} disabled={true} placeholder="" />
                </div>
                <div className="col-12 field">
                  <label htmlFor="toAll" className="text-900 font-semibold">
                    Poslať všetkým aktívnym poradcom
                  </label>
                  <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                    <Checkbox
                      id="toAll"
                      value={data?.toAll}
                      disabled={true}
                      className="w-full pl-7 text-900 font-semibold"
                      style={{ height: '3.5rem' }}
                      checked={data?.toAll}
                    />
                  </span>
                </div>
              </>
            )}
            <div className="col-12 field">
              <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                <h2>{data?.subject}</h2>
              </span>
            </div>
            {isAdminOrAssistant && (
              <div className="col-12 field">
                <label htmlFor="insuranceCompany" className="text-900 font-semibold">
                  Spoločnosť
                </label>
                <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                  {data?.insuranceCompany?.name}
                </span>
              </div>
            )}
            <div id="message" className="col-12 field">
              <span dangerouslySetInnerHTML={{ __html: data?.message }}></span>
            </div>
            <div className="col-12">
              <DataTable
                stripedRows
                value={prilohy}
                size="small"
                dataKey="id"
                emptyMessage="Žiadne prílohy"
                sortField="id"
                sortOrder={SortOrder.DESC}
                header={header}
              >
                <Column field="originalFilename" header="Názov prílohy" />
                <Column field="fileSize" header="Veľkosť" body={v => v?.fileSize / 1000 + ' KB'} />
                <Column body={actionBodyDocumentsTemplate} header="Akcie" exportable={false} style={{ justifyContent: 'end' }}></Column>
              </DataTable>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MailInboxDetail;
